function getTopLeft (center, boxDimensions) {
  return {
    x: center.x - (boxDimensions.width / 2),
    y: center.y - (boxDimensions.height / 2)
  };
}

function getBottomRight (center, boxDimensions) {
  return {
    x: center.x + (boxDimensions.width / 2),
    y: center.y + (boxDimensions.height / 2)
  };
}

function fits (direction, anchorPoint, boxDimensions, containerDimensions, labelDimensions) {
  if (!direction || !anchorPoint || !boxDimensions || !containerDimensions || !labelDimensions) {
    return false;
  }

  var centerPoint;

  switch (direction) {
    case 'above':
    default:
      centerPoint = {
        x: anchorPoint.x,
        y: anchorPoint.y - (boxDimensions.height / 2)// - (labelDimensions.height / 2)
      };
      break;
    case 'left':
      centerPoint = {
        x: anchorPoint.x - (boxDimensions.width / 2), // - (labelDimensions.width / 2),
        y: anchorPoint.y
      };
      break;
    case 'right':
      centerPoint = {
        x: anchorPoint.x + (boxDimensions.width / 2),// + (labelDimensions.width / 2),
        y: anchorPoint.y
      };
      break;
    case 'below':
      centerPoint = {
        x: anchorPoint.x,
        y: anchorPoint.y + (boxDimensions.height / 2)// + (labelDimensions.height / 2)
      };
      break;
    case 'topLeft':
      centerPoint = {
        x: anchorPoint.x - (boxDimensions.width / 2),
        y: anchorPoint.y - (boxDimensions.height / 2)
      };
      break;
    case 'topRight':
      centerPoint = {
        x: anchorPoint.x + (boxDimensions.width / 2),
        y: anchorPoint.y - (boxDimensions.height / 2)
      };
      break;
    case 'bottomLeft':
      centerPoint = {
        x: anchorPoint.x - (boxDimensions.width / 2),
        y: anchorPoint.y + (boxDimensions.height / 2)
      };
      break;
    case 'bottomRight':
      centerPoint = {
        x: anchorPoint.x + (boxDimensions.width / 2),
        y: anchorPoint.y + (boxDimensions.height / 2)
      };
      break;
  }

  // now that we have decoded the centerPoint for this direction
  // check if the top/left and bottom/right corners fit inside the container
  var topLeftPoint = getTopLeft(centerPoint, boxDimensions);
  var bottomRightPoint = getBottomRight(centerPoint, boxDimensions);

  if (topLeftPoint.x >= 0 && topLeftPoint.y >= 0 && bottomRightPoint.x <= containerDimensions.width && bottomRightPoint.y <= containerDimensions.height) {
    topLeftPoint.direction = direction;
    return topLeftPoint;
  }
  else {
    return false;
  }
}

// order of best locations for the box
var directions = ['above', 'left', 'right', 'below', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'];

export default  {
  best: function (anchorPoint, boxDimensions, containerDimensions, labelDimensions) {
    for (var i = 0; i < directions.length; ++i) {
      var direction = directions[i];
      var locationResult = fits(direction, anchorPoint, boxDimensions, containerDimensions, labelDimensions);

      if (locationResult) {
        return locationResult; // good location result (top and left coordinates returned)
      }
    }
    return false;
  }
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/tooltip/fitting.js